import { render, staticRenderFns } from "./BiGroupingCompareBox.vue?vue&type=template&id=48fc8921&"
import script from "./BiGroupingCompareBox.vue?vue&type=script&lang=js&"
export * from "./BiGroupingCompareBox.vue?vue&type=script&lang=js&"
import style0 from "./BiGroupingCompareBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports